(ns minorodata.webhooks.subs
  (:require
   [re-frame.core :as re-frame]))

(re-frame/reg-sub
 :webhooks.subs/transform-triggers
 :<- [:webhook-trigger/pull-many]
 (fn [triggers [_ master-id]]
   (filter #(= master-id (get-in % [:webhook-trigger/params :master-id])) triggers)))

(re-frame/reg-sub
 :webhooks.subs/transform-webhooks
 :<- [:webhook/pull-many]
 (fn [webhooks [_ master-id]]
   (filter #(= master-id (:webhook/source-master-id %)) webhooks)))
